/**
 * A zipson writer takes a piece of zipson compression output as a string
 */
export class ZipsonWriter {
}
/**
 * Writes zipson compression outupt in full to a string
 */
export class ZipsonStringWriter extends ZipsonWriter {
    constructor() {
        super(...arguments);
        this.value = '';
    }
    write(data) {
        this.value += data;
    }
    end() { }
}
